import React from 'react'
import { Box, Heading } from 'grommet'
import styled from 'styled-components'

const TitleBox = styled(Box)`
  height: 49px;
  border-top: 4px double;
  border-bottom: 4px double;
  border-color: inherit;
  margin: 5px 15px 0;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
`

const Title = ({ children }) => {
  return (
    <TitleBox>
      <Heading level={3} margin="0" truncate fill size="22px" color="inherit">
        {children}
      </Heading>
    </TitleBox>
  )
}

export default Title
